export const team = [
  {
    name: "Laoise",
    role: "Director & Founder",
    image: "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/mpx8751z_mum.jpg",
    bio: "Laoise founded PeerWave with a simple belief — that everyone deserves a place where they feel seen, heard and empowered to grow. She leads the team and sets the vision.",
  },
  {
    name: "Carina",
    role: "Support Worker",
    image: "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/qhe5gj2y_Screenshot_20260702-163117~2.jpg",
    bio: "Carina brings warmth and patience to every session. Whether it's painting, community outings or just a chat, she meets participants exactly where they are.",
  },
  {
    name: "Sharon",
    role: "Support Worker",
    image: null,
    initials: "SL",
    bio: "Sharon is calm, thoughtful and endlessly patient. She listens twice as much as she speaks and has a knack for remembering the small things that matter most to the people she works with.",
  },
  {
    name: "Genevieve",
    role: "Admin & Tech",
    image: "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/a74gu9ag_evie.jpg",
    bio: "Genevieve keeps the wheels turning behind the scenes — bookings, plans, tech and a hundred tiny details so support workers can focus on people.",
  },
  {
    name: "Mikayla",
    role: "Admin & Support Worker",
    image: "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/mok5c8gl_mikalya.jpg",
    bio: "Mikayla wears two hats beautifully — sorting the admin one hour, side-by-side with participants the next. Kind, sharp and impossible not to like.",
  },
  {
    name: "Liam",
    role: "Support Worker",
    image: null,
    bio: "Liam brings a grounded, easy-going presence to every shift. He's the kind of support worker who makes hard days feel a little lighter and simple moments feel meaningful.",
  },
  {
    name: "Kyle",
    role: "Support Worker",
    image: null,
    bio: "Kyle is dependable, down-to-earth and quick to lend a hand. He treats every participant like family and never rushes a moment that matters.",
  },
];
